import React, { useState, useEffect } from "react";
import { Button } from "antd";

const About = props => {
  const [pageNum, setPage] = useState(0);

  useEffect(() => {
    props.fetchCategories();
  }, []);

  if (props.redux.loading === true) {
    return <div></div>;
  }

  const contactInfo = (
    <div className="ibox center">
      <h2>
        <strong>Equipment Finder</strong>
      </h2>
      <div className="noBreak">
        <div>Copyright 2020 by Rain for Rent</div>
        <div>
          <strong>Version</strong> 1.1.0
        </div>
        <div>
          E-mail RFR IT Help Desk for support{" "}
          <a href="mailto:helpdesk@rainforrent.com?subject=Equipment%20Finder%20Support%20Request">
            helpdesk@rainforrent.com
          </a>
        </div>
        <div>
          or call{" "}
          <a href="tel:+1(661)634-6800" style={{ width: "100px" }}>
            +1 (661)634-6800
          </a>
        </div>
      </div>
    </div>
  );

  const pagers = () => {
    return (
      <div className="pdfControll padding">
        {pageNum !== 0 ? (
          <Button onClick={() => setPage(pageNum - 1)}>Prev page</Button>
        ) : (
            <Button disabled>Prev page</Button>
          )}

        {pageNum !== imagesPath.length - 1 ? (
          <Button onClick={() => setPage(pageNum + 1)}>Next page</Button>
        ) : (
            <Button disabled>Prev page</Button>
          )}
      </div>
    );
  };

  const imagesPath = ["/EFGuide0.jpg", "/EFGuide1.jpg", "/EFGuide2.jpg", "/EFGuide3.jpg", "/EFGuide4.jpg", "/EFGuide5.jpg",];

  return (
    <>
      {contactInfo}
      <div className="ibox paddingBox">
        <h2 className="padding">
          <strong>User Guide</strong>
        </h2>
        <a
          className="padding"
          href={`${process.env.PUBLIC_URL}/assets/EFUserGuide.pdf`}
          download
        >
          <Button type="primary">Download</Button>
        </a>
        {pagers()}
        <div className="pdf">
          <img
            src={`${process.env.PUBLIC_URL}/assets${imagesPath[pageNum]}`}
            alt={`/assets${imagesPath[pageNum]}`}
          />
        </div>
        {pagers()}
      </div>
    </>
  );
};

export default About;
